import { buildComponent } from '#components'

import './option-pair.css'

const OptionPair = buildComponent({
  name: 'option-pair',
  onConnected: (component) => {
    const optionPair = component.querySelector('.js-pair-input')
    const optionOneSize = document.querySelector('.js-option-values-jewelry > input')
    const labelOneSize = document.querySelector('.js-option-values-jewelry > label')
    const increaseBtn = document.querySelector('.quantity-selector__button--increase') as HTMLElement
    const decreaseBtn = document.querySelector('.quantity-selector__button--decrease') as HTMLElement
    const buyButtons = document.querySelectorAll('.js-buy-buttons') as NodeListOf<HTMLElement>
    const shopPayBtn = document.querySelector('.js-shoppay-button') as HTMLElement

    const updateQuantityBasedOnSelection = () => {
      if (optionPair && optionPair.classList.contains('active')) return
      if (optionPair && increaseBtn) increaseBtn.click()
    }

    const handlePairButton = () => {
      if (optionPair) {
        optionPair.addEventListener('click', function() {
          updateQuantityBasedOnSelection()
          optionPair.classList.add('active')
          if (optionOneSize) optionOneSize.removeAttribute('checked')
          if (labelOneSize && labelOneSize.classList.contains('is-selected')) labelOneSize.classList.remove('is-selected')

          if (buyButtons && buyButtons.length > 0) {
            buyButtons.forEach((button) => {
              const addToCartBtn = button.querySelector("button[type='submit']")
              const buyItNowBtn = button.querySelector('shopify-accelerated-checkout')
              if (addToCartBtn) addToCartBtn.removeAttribute('disabled')
              if (buyItNowBtn) buyItNowBtn.removeAttribute('disabled')
              if (shopPayBtn) shopPayBtn.classList.add('is-active')
            })
          }
        })
      }
    }

    const handleOneSizeButton = () => {
      if (optionOneSize) {
        optionOneSize.addEventListener('click', function() {
          if (optionPair && optionPair.classList.contains('active')) optionPair.classList.remove('active')
          if (decreaseBtn) decreaseBtn.click()
        })
      }
    }

    handlePairButton()
    handleOneSizeButton()
  },
});

declare global {
  interface HTMLElementTagNameMap {
    'option-pair': typeof OptionPair
  }
}
